import { get } from 'lodash'
import { createSelector } from 'reselect'

const getNotifications = (streamNotifications, homeId) =>
  get(streamNotifications, [homeId, 'notifications'], [])

export const selectNotifications = createSelector(
  state => state.streamNotifications,
  state => get(state, 'home.data.id'),
  getNotifications
)
